export const REQUEST_EXTENSIONS_HEADER_PREFIX = "x-lg-ext-";
const normalizeExtensionKeyForHeader = (key) => {
    const normalized = key
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9_]/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_+|_+$/g, "");
    return normalized || undefined;
};
const normalizeExtensionKeyFromHeader = (headerName) => {
    if (!headerName.startsWith(REQUEST_EXTENSIONS_HEADER_PREFIX)) {
        return undefined;
    }
    const suffix = headerName.slice(REQUEST_EXTENSIONS_HEADER_PREFIX.length);
    const normalized = suffix
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "")
        .replace(/-/g, "_");
    return normalized || undefined;
};
export const serializeRequestMetadataExtensions = (ext) => {
    if (!ext || Object.keys(ext).length === 0) {
        return {};
    }
    const headers = {};
    for (const [rawKey, rawValue] of Object.entries(ext)) {
        const key = normalizeExtensionKeyForHeader(rawKey);
        const value = typeof rawValue === "string" ? rawValue.trim() : "";
        if (!key || !value) {
            continue;
        }
        headers[`${REQUEST_EXTENSIONS_HEADER_PREFIX}${key.replace(/_/g, "-")}`] = value;
    }
    return headers;
};
export const parseRequestMetadataExtensions = (headers) => {
    const ext = {};
    for (const [headerName, rawValue] of Object.entries(headers)) {
        const key = normalizeExtensionKeyFromHeader(headerName);
        if (!key) {
            continue;
        }
        const value = Array.isArray(rawValue) ? rawValue[0] : rawValue;
        const trimmedValue = typeof value === "string" ? value.trim() : "";
        if (!trimmedValue) {
            continue;
        }
        ext[key] = trimmedValue;
    }
    return Object.keys(ext).length ? ext : undefined;
};
const isObjectRecord = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
export const mergeRequestMetadataExtensions = (extensionSets) => {
    const merged = {};
    for (const extensionSet of extensionSets) {
        if (!extensionSet || !isObjectRecord(extensionSet)) {
            continue;
        }
        for (const [key, value] of Object.entries(extensionSet)) {
            if (typeof value !== "string" || value.trim() === "") {
                continue;
            }
            merged[key] = value.trim();
        }
    }
    return Object.keys(merged).length ? merged : undefined;
};
export const makeCompositeRequestMetadataExtensionsResolver = (resolvers) => {
    const activeResolvers = resolvers.filter(Boolean);
    if (activeResolvers.length === 0) {
        return async () => undefined;
    }
    return async () => {
        const results = await Promise.all(activeResolvers.map(async (resolve) => {
            try {
                return await resolve();
            }
            catch {
                return undefined;
            }
        }));
        return mergeRequestMetadataExtensions(results);
    };
};
